<template>
    <li
        class="nav-item dropdown"
        @click="toggleDropDown"
        v-click-outside="closeDropDown"
    >
        <a
            class="nav-link pr-0"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
        >
            <div class="media align-items-center">
                <span class="avatar avatar-sm rounded-circle">
                    <img alt="profile" :src="image(user.photo)" />
                </span>
                <div class="media-body ml-2 d-none d-lg-block">
                    <span
                        :style="{ color: color.secondary }"
                        class="mb-0 text-sm font-weight-bold"
                    >{{ $trim(user.name, 15) }}</span>
                </div>
            </div>
        </a>
        <div
            class="dropdown-menu"
            :class="[{ show: isOpen }, { 'dropdown-menu-right': direction }]"
        >
            <template v-if="$mq !== 'sm'">
                <div class="dropdown-header noti-title">
                    <h6 class="text-overflow m-0">
                        {{ $t('header.profile.welcome') }}
                    </h6>
                </div>
                <div class="dropdown-divider"></div>
                <a href="/app/panel/profile" class="dropdown-item">
                    <i class="ni ni-ui-04"></i>
                    <span>{{ $t('header.profile.title') }}</span>
                </a>
                <!-- Wiki colaborativa (backlog#343) -->
                <a v-if="wikiEnabled" href="/app/wikis" class="dropdown-item nch--my-wikis-link">
                    <i class="fas fa-book"></i>
                    <span>{{ $t('wiki.my_wikis') }}</span>
                </a>
                <a href="#!" class="dropdown-item" @click="logoutUser">
                    <i class="ni ni-user-run"></i>
                    <span>{{ $t('header.profile.logout') }}</span>
                </a>
            </template>
            <template v-else>
                <ul class="nav nav-sm flex-column">
                    <div class="dropdown-header noti-title">
                        <h6 class="text-overflow m-0">
                            {{ $t('header.profile.welcome') }}
                        </h6>
                    </div>

                    <div class="dropdown-divider"></div>

                    <li class="nav-item">
                        <a href="#!" class="dropdown-item nch--nav-link">
                            <i class="ni ni-bell-55"></i>
                            <span>{{$t('header.profile.notifications')}}</span>
                            <badge :style="$bgColor(color.primary)">
                                {{notifications}}
                            </badge>
                        </a>
                    </li>
                    <!-- multilevel menu -->
                    <li class="nav-item">
                        <a
                            href="#!"
                            class="dropdown-item nch--nav-link"
                            data-toggle="collapse"
                            role="button"
                            aria-expanded="true"
                            aria-controls="navbar-multilevel"
                            @click.stop="toggleMultiLevel"
                        >
                            <i class="ni ni-ungroup"></i>
                            <span class="nav-link-text">Menus</span>
                        </a>
                        <slide-x-left-transition :duration="600" :delay="100">
                            <div
                                class="collapse show"
                                v-show="isShow"
                                id="navbar-multilevel"
                            >
                                <ul class="nav nav-sm flex-column">
                                    <li class="nav-item">
                                        <a
                                            href="#!"
                                            class="pl-4 dropdown-item nch--nav-link"
                                        >Calendar</a>
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="#!"
                                            class="pl-4 dropdown-item nch--nav-link"
                                        >Email</a>
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="#!"
                                            class="pl-4 dropdown-item nch--nav-link"
                                        >Payments</a>
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="#!"
                                            class="pl-4 dropdown-item nch--nav-link"
                                        >Reposts</a>
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="#!"
                                            class="pl-4 dropdown-item nch--nav-link"
                                        >Maps</a>
                                    </li>
                                    <li class="nav-item">
                                        <a
                                            href="#!"
                                            class="pl-4 dropdown-item nch--nav-link"
                                        >Cart</a>
                                    </li>
                                </ul>
                            </div>
                        </slide-x-left-transition>
                    </li>

                    <li class="nav-item">
                        <a href="#!" class="dropdown-item nch--nav-link">
                            <i class="ni ni-cart"></i>
                            <span>{{ $t('header.profile.cart') }}</span>
                            <badge
                                :style="[
                                    $bgColor(color.primary),
                                    { color: color.secondary },
                                ]"
                                type=""
                            >{{ cart }}</badge>
                        </a>
                    </li>

                    <div class="dropdown-divider"></div>

                    <li class="nav-item nch--nav-link">
                        <a
                            href="#!"
                            class="dropdown-item nch--nav-link"
                            @click="logoutUser"
                        >
                            <i class="ni ni-user-run"></i>
                            <span>{{ $t('header.profile.logout') }}</span>
                        </a>
                    </li>
                </ul>
            </template>
        </div>
    </li>
</template>

<script>
import Badge from '../../argon/components/Badge';
import imageMixin from '../../mixins/image';

export default {
    name: 'Profile',
    mixins: [imageMixin],
    data() {
        return {
            isOpen: false,
            isShow: false,
        };
    },
    props: {
        // Wiki colaborativa ligada no painel God (backlog#343)
        wikiEnabled: {
            type: Boolean,
            default: false,
        },
        user: {
            type: Object,
        },
        notifications: {
            type: Number,
        },
        cart: {
            type: Number,
        },
        color: {
            type: Object,
        },
    },
    components: {
        Badge,
    },
    computed: {
        direction() {
            return !this.$store.getters.NAVBAR_POSITION;
        },
    },
    mounted() {
        this.$store.commit('SET_USER_PHOTO', this.image(this.user.photo));
        if (this.user.student && this.user.student.student) {
            this.$store.commit('SET_STUDENT', this.user.student.student);
        }
    },
    methods: {
        toggleMultiLevel() {
            this.isShow = !this.isShow;
        },

        toggleDropDown() {
            this.isOpen = !this.isOpen;
            this.$emit('change', this.isOpen);
        },

        closeDropDown() {
            this.isShow = false;
            this.isOpen = false;
            this.$emit('close', this.isOpen);
        },

        logoutUser() {
            this.$loading.show();

            window.axios
                .post('/logout')
                .then(() => {
                    setTimeout(() => {
                        localStorage.removeItem('nochalks_token');
                        location.href = '/';
                    }, 150);
                })
                .catch(() => {
                    setTimeout(() => {
                        this.$notify({
                            type: 'danger',
                            message: this.$t('login.messages.error'),
                        });
                    }, 150);
                });
        },
    },
};
</script>

<style>
.nch--nav-link {
    color: #525f7f !important;
}
</style>
